module.exports = __webpack_public_path__ + "static/media/LinkedIn.7e37a93b.svg";